export const styles = (theme) => ({
  root: {
    marginTop: theme.spacing(2),
    padding: 0,
    width: "100%",
  },
  container: {
    display: "flex",
    flexWrap: "wrap",
    flexDirection: "column",
    padding: theme.spacing(3),
    backgroundColor: theme.palette.background.paper,
    boxShadow:
      "0px 1px 3px 0px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 2px 1px -1px rgba(0, 0, 0, 0.12);",
  },
  // Top Bar
  topBar: {
    height: "3rem",
    backgroundColor: "rgba(177, 178, 181, 0.25)",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  topBarLeft: {
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
  },
  topBarRight: {
    display: "flex",
    alignItems: "center",
  },
  arrowPackage: {
    width: 0,
    height: 0,
    borderTop: "1.5rem solid transparent",
    borderBottom: "1.5rem  solid transparent",
  },
  packageName: {
    width: "5rem",
    height: "3rem",
    // backgroundColor: '#eebe00',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontWeight: "bold",
    textTransform: "capitalize",
  },
  packageName_gold: {
    backgroundColor: "#eebe00",
  },
  arrowPackage_gold: {
    borderLeft: "1.5rem  solid #eebe00",
  },
  packageName_basic: {
    backgroundColor: "#1ea000",
  },
  arrowPackage_basic: {
    borderLeft: "1.5rem  solid #1ea000",
  },
  packageName_bronze: {
    backgroundColor: "#f37f00",
  },
  arrowPackage_bronze: {
    borderLeft: "1.5rem  solid #f37f00",
  },
  packageName_silver: {
    backgroundColor: "#9497a3",
  },
  arrowPackage_silver: {
    borderLeft: "1.5rem  solid #9497a3",
  },
  packageName_custom: {
    backgroundColor: "#3F98FF",
  },
  arrowPackage_custom: {
    borderLeft: "1.5rem  solid #3F98FF",
  },
  link: {
    cursor: "pointer",
    textDecoration: "underline",
    marginLeft: "1rem",
  },
  button: {
    minWidth: "8rem",
    margin: "0.5rem",
  },
  popupPackage: {
    backgroundColor: "#FFF",
  },
  menuItem: {
    color: "#000",
    textTransform: "capitalize",
  },
});
